import Vue from "vue";
import moment from "moment";

Vue.filter("date", function (value, format = "D MMMM YYYY, HH:mm") {
    if (value) {
        return moment(value).format(format);
    }
});
Vue.filter("dateShorted", function (value, format = "D MMMM, HH:mm") {
    if (value) {
        return moment(value).format(format);
    }
});

Vue.filter("ago", function (value) {
    if (value) {
        return moment(value).fromNow();
    }
});

Vue.filter("dateToHour", function (value) {
    if (value) {
        return moment(value).format("HH:mm");
    }
});
Vue.filter("dateToHourFromSeconds", function (value) {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return (hours !== "00" ? hours + ":" : "") + minutes + ":" + seconds;
});

export function dateToHourFromSecondsShortFormat(value, lang, secondVisible = true) {
    const literals = {
        day: lang === "en" ? "day" : "gün",
        hour: lang === "en" ? "hour" : "saat",
        min: lang === "en" ? "min" : "dk",
        sec: lang === "en" ? "sec" : "sn",
    };
    let sec_num = parseInt(value, 10); // don't forget the second param
    let days = Math.floor(sec_num / 86400);
    let hours = Math.floor((sec_num - days * 86400) / 3600);
    let minutes = Math.floor((sec_num - hours * 3600 - days * 86400) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60 - days * 86400;
    let result = "";

    if (days >= 1) {
        result += `${days}${literals.day}`;
    } else {
        if (hours > 0) {
            result += `${hours}${literals.hour}`;
        }
        if (minutes > 0) {
            result += result.length ? ` ${minutes}${literals.min}` : `${minutes}${literals.min}`;
        }
        if (seconds >= 0) {
            if (secondVisible) {
                result += result.length ? ` ${seconds}${literals.sec}` : `${seconds}${literals.sec}`;
            } else {
                if (hours === 0 && minutes === 0) {
                    result += result.length ? ` ${seconds}${literals.sec}` : `${seconds}${literals.sec}`;
                }
            }
        }
    }
    return result;
}

Vue.filter("dateToHourFromSecondsShortFormat", function (value, lang, secondVisible = true) {
    const literals = {
        day: lang === "en" ? "d" : "g",
        hour: lang === "en" ? "h" : "s",
        min: lang === "en" ? "min" : "dk",
        sec: lang === "en" ? "sec" : "sn",
    };
    let sec_num = parseInt(value, 10); // don't forget the second param
    let days = Math.floor(sec_num / 86400);
    let hours = Math.floor((sec_num - days * 86400) / 3600);
    let minutes = Math.floor((sec_num - hours * 3600 - days * 86400) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60 - days * 86400;
    let result = "";

    if (days >= 1) {
        result += `${days}${literals.day}`;
    } else {
        if (hours > 0) {
            result += `${hours}${literals.hour}`;
        }
        if (minutes > 0) {
            result += result.length ? ` ${minutes}${literals.min}` : `${minutes}${literals.min}`;
        }
        if (seconds >= 0) {
            if (secondVisible) {
                result += result.length ? ` ${seconds}${literals.sec}` : `${seconds}${literals.sec}`;
            } else {
                if (hours === 0 && minutes === 0) {
                    result += result.length ? ` ${seconds}${literals.sec}` : `${seconds}${literals.sec}`;
                }
            }
        }
    }
    return result;
});

Vue.filter("timeDiff", function (startDate, endDate = null) {
    return moment.utc(moment(endDate).diff(moment(startDate))).format("HH:mm:ss");
});
const twoUnitTimeFilter = function (value, lang) {
    const literals = {
        month: lang === "en" ? "mo" : "ay",
        week: lang === "en" ? "w" : "h",
        day: lang === "en" ? "d" : "g",
        hour: lang === "en" ? "h" : "s",
        min: lang === "en" ? "min" : "dk",
        sec: lang === "en" ? "sec" : "sn",
    };
    let sec_num = parseInt(value, 10); // don't forget the second param
    let months = Math.floor(sec_num / 2592000);
    let weeks = Math.floor((sec_num - months * 2592000) / 604800);
    let days = Math.floor((sec_num - weeks * 604800 - months * 2592000) / 86400);
    let hours = Math.floor((sec_num - days * 86400 - weeks * 604800 - months * 2592000) / 3600);
    let minutes = Math.floor((sec_num - hours * 3600 - days * 86400 - weeks * 604800 - months * 2592000) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60 - days * 86400 - weeks * 604800 - months * 2592000;

    let result = "";

    if (months >= 1) {
        result += result.length ? `${months}${literals.month}` : `${months}${literals.month}`;
        result += weeks > 0 ? ` ${weeks}${literals.week}` : "";
    } else if (months <= 0 && weeks > 0) {
        result += result.length ? `${weeks}${literals.week}` : `${weeks}${literals.week}`;
        result += days > 0 ? ` ${days}${literals.day}` : "";
    } else if (weeks <= 0 && days >= 1) {
        result += result.length ? `${days}${literals.day}` : `${days}${literals.day}`;
        result += hours > 0 ? ` ${hours}${literals.hour}` : "";
    } else if (days <= 0 && hours > 0) {
        result += result.length ? `${hours}${literals.hour}` : `${hours}${literals.hour}`;
        result += minutes > 0 ? ` ${minutes}${literals.min}` : "";
    } else if (days <= 0 && hours <= 0 && minutes > 0) {
        result += result.length ? ` ${minutes}${literals.min}` : `${minutes}${literals.min}`;
        result += seconds > 0 ? ` ${seconds}${literals.sec}` : "";
    } else {
        result += result.length ? ` ${seconds}${literals.sec}` : `${seconds}${literals.sec}`;
    }
    return result;
};
Vue.filter("twoUnitTimeFilter", twoUnitTimeFilter);

export const VUE_FILTERS = { twoUnitTimeFilter };
